/* eslint-disable @typescript-eslint/no-unused-vars */

/**
 * chat_widget/src/bootstrap.tsx
 */

import type { WidgetInitOptions } from "./widget/types/widgetTypes";
import { App } from "./widget/ui/App";

export function createWidgetApp(
  options: WidgetInitOptions,
  _shadowRoot: ShadowRoot,
) {
  return <App options={options} />;
}
